// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","prev":"Pagination_prev__M5Yp8","arrow-box":"Pagination_arrow-box__mGry3","active":"Pagination_active__q3h4d"};